import { render } from "./PageFailedView.vue?vue&type=template&id=48fd17e3&scoped=true"
import script from "./PageFailedView.vue?vue&type=script&lang=js"
export * from "./PageFailedView.vue?vue&type=script&lang=js"

import "./PageFailedView.vue?vue&type=style&index=0&id=48fd17e3&scoped=true&lang=css"

import exportComponent from "/Users/rhylton/Sites/projeto-obras/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48fd17e3"]])

export default __exports__